<template>
  <modal-confirm
    title="이메일 주소 등록"
    :description="`자동 결제 알림을 수신한 이메일 주소를 등록해주세요.\n사용 중인 이메일 주소를 등록해야 쿠폰 사용이 가능합니다.`"
    @on-click-close="$emit('on-click-close')"
    @on-click-submit="onClickSubmit"
  >
    <template #content>
      <div class="input-area">
        <label class="a11y-hidden" for="register-email"
          ><span>이메일 주소</span></label
        >
        <input
          id="register-email"
          type="text"
          title="프로필 이름 변경 입력 영역"
          :value="emailValue"
          placeholder="이메일 주소를 입력해주세요 (필수)"
          @input="setInput($event)"
        />
      </div>
      <div class="notice-area">
        <ul>
          <li>
            <p>
              <i class="icon-empty"></i>
              <span
                >로그인, 비밀번호 찾기, 알림에 사용되니 정확한 이메일을
                입력해주세요.</span
              >
            </p>
          </li>
        </ul>
      </div>
    </template>
    <template #confirm>등록</template>
  </modal-confirm>
</template>
<script setup>
  import { ref, defineEmits } from 'vue'
  import { checkValidEmail } from '@/common/utils/check-valid-email'
  import { MSG_INVALID_EMAIL } from '@/common/utils/coupon/const'
  import ModalConfirm from '@/components/ui/Modal/ModalConfirm.vue'

  const emit = defineEmits(['on-click-submit', 'on-click-close'])

  const emailValue = ref('')

  const setInput = (e) => {
    emailValue.value = e.target.value
  }

  const onClickSubmit = () => {
    const isValid = checkValidEmail(emailValue.value)
    if (!isValid) {
      window.alert(MSG_INVALID_EMAIL)
      emailValue.value = ''
      return undefined
    }

    emit('on-click-submit', emailValue.value)
  }
</script>

<style scoped lang="scss">
  .input-area {
    margin-top: 40px;
    input {
      width: 480px;
      height: 54px;
      padding: 0 20px;
      border: 1px solid #2f2f2f;
      border-radius: 8px;
      background-color: #2f2f2f;
      font-size: 16px;
      color: #a5a5a5;
    }
  }
  .notice-area {
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
    ul {
      li {
        > p {
          display: flex;
          .icon-empty {
            display: block;
            width: 20px;
            height: 20px;
            background: url(~@/assets/images/common/icon-error-74.png) no-repeat
              center / 15px;
          }
          > span {
            display: block;
            margin-left: 2px;
          }
        }
      }
    }
  }
</style>
